var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_30243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9994C0 13.4672 0.264047 14.8733 0.746391 16.1732L12 17.2167L23.2536 16.1732C23.736 14.8733 24 13.4672 24 11.9994C24 10.5315 23.736 9.12545 23.2536 7.82547L12 6.78198L0.746391 7.82547C0.264047 9.12545 0 10.5315 0 11.9994Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2553 7.82587C21.5597 3.2563 17.1612 -0.000244141 12.0017 -0.000244141C6.84208 -0.000244141 2.44356 3.2563 0.748047 7.82587H23.2553Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.74707 16.1741C2.44259 20.7436 6.8411 24.0002 12.0007 24.0002C17.1603 24.0002 21.5588 20.7436 23.2543 16.1741H0.74707Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_30243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.7c3827ff6707add580aaea850879809d.svg";
export { ForwardRef as ReactComponent };